(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var App = /*#__PURE__*/_createClass(function App() {
  _classCallCheck(this, App);
  console.info('ES6 Modules work!');
  AOS.init();
  // new WOW().init();

  // $(document).ready(function(){
  //   $("p").click(function(){
  //     $(this).hide();
  //   });
  // });
  jQuery(document).ready(function ($) {
    // $("p").click(function(){
    //     $(this).hide();
    //   });
    //////////////////////////////////////////////
    /* page scroll top on click function */
    jQuery("button.back-to-top").on('click', function () {
      jQuery('html').animate({
        scrollTop: 0
      }, 500);
      return false;
    });
    jQuery(window).on("scroll", function () {
      var scrollWindowHeight = jQuery(window).scrollTop();
      if (scrollWindowHeight > 900) {
        jQuery("button.back-to-top").slideDown(1000).fadeIn(1000);
      } else {
        jQuery("button.back-to-top").slideUp(1000).fadeOut(1000);
      }
    });
    /* page scroll top on click function end*/
    ///////////////////////////////////////////////////////        
    // Add smooth scrolling to all links

    $("a").on('click', function (event) {
      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 800, function () {
          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash;
        });
      } // End if
    });
    // ////////////////////////
    var btn = $('#button');
    $(window).scroll(function () {
      // $("#contactForm").validate();

      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });
    btn.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, '300');
    });
    ///////////////////////

    $('#njSubscribeForm').on('submit', function (e) {
      e.preventDefault();
      console.log('form submitted');
      $('.is-invalid').removeClass('is-invalid');
      $('.js-show-feedback').removeClass('js-show-feedback');
      var form = $(this),
        email = form.find('#email').val(),
        ajaxurl = form.data('url');
      // console.log(form);
      // console.log(email);
      /*Security Checks*/

      if (email === '') {
        console.log('Required inputs are empty');
        $('#email').parent('.input-group').addClass('is-invalid').find('.form-control').addClass('is-invalid');
        return;
      }
      form.find('input, button').attr('disabled', 'disabled');
      $('.js-form-submission').addClass('js-show-feedback');
      $.ajax({
        url: ajaxurl,
        type: 'post',
        data: {
          email: email,
          action: 'nj_save_user_subscribe_form'
        },
        error: function error(response) {
          // console.log(response);
          $('.js-form-submission').removeClass('js-show-feedback');
          $('.js-form-error').addClass('js-show-feedback');
          form.find('input, button').removeAttr('disabled');
          $('.js-form-submission').removeClass('js-show-feedback');
          $('.js-form-error').addClass('js-show-feedback');
          form.find('input, button').removeAttr('disabled');
        },
        success: function success(response) {
          if (response == 0) {
            setTimeout(function () {
              $('.js-form-submission').removeClass('js-show-feedback');
              $('.js-form-error').addClass('js-show-feedback');
              form.find('input, button').removeAttr('disabled');
            }, 2000);
          } else {
            setTimeout(function () {
              $('.js-form-submission').removeClass('js-show-feedback');
              $('.js-form-success').addClass('js-show-feedback');
              form.find('input, button').removeAttr('disabled').val('');
            }, 2000);
          }
        }
      });
      /*Ajax End*/
    });
    /////////////////////////////////
    /////////////////////////////////////////

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll > 10) {
        $(".nav-links-container").addClass("scrolled");
      } else {
        $(".nav-links-container").removeClass("scrolled");
      }
    });
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll > 734) {
        $(".headerlink").addClass("show");
        // $(".sliderlink").addClass("hide");
        $(".nav-links").addClass("addpad");
      } else {
        $(".headerlink").removeClass("show");
        // $(".sliderlink").removeClass("hide");
        $(".nav-links").removeClass("addpad");
      }
    });
    // /////
    // $( ".dropdown-menu" ).css('margin-top',0);
    // $( ".dropdown" )
    //   .mouseover(function() {
    //     $( this ).addClass('show').attr('aria-expanded',"true");
    //     $( this ).find('.dropdown-menu').addClass('show transform: scale(1)');
    //   })
    //   .mouseout(function() {
    //     $( this ).removeClass('show').attr('aria-expanded',"false");
    //     $( this ).find('.dropdown-menu').removeClass('show');
    //   });
    //////
    $('.owl-carousel').owlCarousel({
      loop: true,
      center: true,
      margin: 10,
      // lazyLoad:true,
      // transitionStyle : "fade",
      autoplay: true,
      smartSpeed: 250,
      dots: true,
      // autoplayTimeout:2000,
      // autoPlay: 2000,
      // nav:true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });
  });
});
var _default = exports.default = App;

},{}],2:[function(require,module,exports){
"use strict";

var _app = _interopRequireDefault(require("./app.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var app = new _app.default();

},{"./app.js":1}]},{},[2]);
